import React, { useState } from 'react'
import { FaXmark } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import { useChangePasswordMutation } from '../../../redux/API/LoginApi'

const ChangePassword = ({setShowPass}) => {
const [passData, setPassData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
})

const [error, setError] = useState("")
const [postData] = useChangePasswordMutation()
const handlePassword = (e) => {
    e.preventDefault()
    if(passData.oldPassword === "" || passData.newPassword === "" || passData.confirmPassword === ""){
        setError("Please Provide Password and Confirm Password")
        setTimeout(() => {
            setError("")
        }, 4000);
        return;
    }
    if(passData.confirmPassword !== passData.newPassword){
        setError("Password and Confirm Password should be same")
        setTimeout(() => {
            setError("")
        }, 4000);
        return;
    }
    postData(passData).then((res) => {
       if(res){
        // console.log(res);
        setShowPass(false)
       }
        else{
            setError("Something went wrong, Please try later")
        }
    })
    .catch((err) => {
        console.log(err);
        
    })
}


  return (
    <>
     <div className="modal position-absolut top-0 start-0 d-flex justify-content-center align-items-center">
     <div className="modal_box_pass bg-white d-flex flex-column justify-content-center align-items-center rounded-2 position-relative">
        <Link onClick={() => setShowPass(false)} className='position-absolute top-0 end-0 mt-3 me-3 fs-5'>
        <FaXmark/>
        </Link>
        <form className='w-100' onSubmit={handlePassword}>
            <h3 className='text-center'>Change Password</h3>
            <p className='wel text-danger mb-4 text-center'>{error}</p>
        <div className='mb-3'>
     <label htmlFor="oldPassword">Old Password</label>
             <input
               type="password"
               className="form-control w-100"
               id="oldPassword"
               name="oldPassword"
               placeholder="Enter Password"
               value={passData.oldPassword}
               onChange={(e) => setPassData({...passData, oldPassword: e.target.value})}
             />
           
            </div>
        <div className='mb-3'>
     <label htmlFor="newPassword">New Password</label>
             <input
               type="password"
               className="form-control w-100"
               id="newPassword"
               name="newPassword"
               placeholder="Enter Password"
               value={passData.newPassword}
               onChange={(e) => setPassData({...passData, newPassword: e.target.value})}
             />
           
            </div>
        <div className='mb-3'>
     <label htmlFor="confirmPassword">Confirm Password</label>
             <input
               type="password"
               className="form-control"
               id="confirmPassword"
               name="confirmPassword"
               placeholder="Enter Password"
               value={passData.confirmPassword}
               onChange={(e) => setPassData({...passData, confirmPassword: e.target.value})}
             />
           
            </div>
            <div className='text-center'>
                <button className='btn btn-primary' type="submit">Submit</button>
            </div>
            </form>
     </div>
     </div>
    </>
  )
}

export default ChangePassword